import getCountry from '@/utils/getCountry.js'

const useNavigateLink = (link) => {
  const region = getCountry() 
  let url = ''
  url = region == 'base' ? link : `/${region}${link}`
  return url
}

export default useNavigateLink